import PropTypes from 'prop-types';

// material-ui
import { Divider, List, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import { useSelector } from 'store';
import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item, open }) => {
    const theme = useTheme();
    const moduleAccessData = useSelector((state) => state.moduleAccess);

    const { moduleAccessMap = {} } = moduleAccessData || {};

    // menu list collapse & items
    const items = item.children?.map((menu) => {
        const moduleAccessObj = moduleAccessMap[menu?.accessId];
        if (moduleAccessObj?.is_active) {
            switch (menu.type) {
                case 'collapse':
                    return <NavCollapse id={menu.id} key={menu.id} menu={menu} level={1} />;
                case 'item':
                    return <NavItem id={menu.id} key={menu.id} item={menu} level={1} open={open} />;
                default:
                    return (
                        <Typography key={menu.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        } else return <></>;
    });

    return (
        <>
            <List
                subheader={
                    item.title && (
                        <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            <Divider sx={{ mt: 0.25, mb: 1.25 }} />
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object,
    open: PropTypes.bool
};

export default NavGroup;
